module.exports = __webpack_public_path__ + "media/images/home/fv_bg-0f297c2296294b6fc55e8c972cffb065.png";